// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEnglish from "./languages/english.json";
import translationFrench from "./languages/french.json";
import translationPortuguese from "./languages/portuguese.json";
import translationSwahili from "./languages/swahili.json";

const resources = {
  0: {
    translation: translationEnglish,
  },
  /* 1: {
        translation: translationFrench
    },
    2:{
        translation:translationPortuguese
    },
    3:{
        translation:translationSwahili
    }*/
  4: {
    translation: translationSwahili,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "0",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
